const pushDataLayer = (data) => {
    window.dataLayer.push({ event: data.event, ecommerce: data.ecommerce });
};
const getProductData = (id, accommodation) => {
    return {
        id,
        name: accommodation.title,
        category: "room",
        dimension1: accommodation.ticker,
        metric1: accommodation.minPrice,
    };
};
export const pushImpressionViewEvent = (accommodations) => {
    if (!accommodations) {
        return;
    }
    const impressions = accommodations.map((it, index) => (Object.assign(Object.assign({}, getProductData(it.ticker, it)), { position: index + 1, list: window.location.hostname })));
    pushDataLayer({
        event: "eec.impressionView",
        ecommerce: { impressions },
    });
};
export const pushImpressionClickEvent = (accommodations) => {
    if (!accommodations) {
        return;
    }
    const products = accommodations.map(it => (Object.assign(Object.assign({}, getProductData(it.ticker, it)), { position: typeof it.position === "number" ? it.position + 1 : undefined })));
    pushDataLayer({
        event: "eec.impressionClick",
        ecommerce: {
            click: {
                actionField: {
                    list: window.location.hostname,
                },
                products,
            },
        },
    });
};
export const pushProductDetailEvent = (propertyTicker, accommodations) => {
    if (!accommodations) {
        return;
    }
    const products = accommodations.map(it => (Object.assign(Object.assign({}, getProductData(it.ticker, it)), { brand: propertyTicker })));
    pushDataLayer({
        event: "eec.detail",
        ecommerce: {
            detail: {
                actionField: {
                    list: window.location.hostname,
                },
                products,
            },
        },
    });
};
export const pushAddToCartEvent = (propertyTicker, cartSelection) => {
    if (!cartSelection) {
        return;
    }
    const products = [
        Object.assign(Object.assign({}, getProductData(cartSelection.ticker, {
            ticker: cartSelection.ticker,
            title: cartSelection.title,
            minPrice: cartSelection.totalRate,
        })), { variant: `${cartSelection.configurationName}, ${cartSelection.mealPlanName}, ${cartSelection.conditionName}`, brand: propertyTicker, quantity: cartSelection.quantity, dimension2: cartSelection.conditionName, dimension3: cartSelection.mealPlanName }),
    ];
    pushDataLayer({
        event: "eec.add",
        ecommerce: {
            add: {
                actionField: {
                    list: window.location.hostname,
                },
                products,
            },
        },
    });
};
export const pushRemoveFromCartEvent = (propertyTicker, cartSelection) => {
    if (!cartSelection) {
        return;
    }
    const products = cartSelection.map(reservation => (Object.assign(Object.assign({}, getProductData(reservation.ticker, {
        ticker: reservation.ticker,
        title: reservation.title,
        minPrice: reservation.totalRate,
    })), { variant: `${reservation.configurationName}, ${reservation.mealPlanName}, ${reservation.conditionName}`, brand: propertyTicker, quantity: reservation.quantity, dimension2: reservation.conditionName, dimension3: reservation.mealPlanName })));
    pushDataLayer({
        event: "eec.remove",
        ecommerce: {
            add: {
                actionField: {
                    list: window.location.hostname,
                },
                products,
            },
        },
    });
};
export const pushCheckoutEvent = (propertyTicker, cartSelection) => {
    if (!cartSelection) {
        return;
    }
    const products = cartSelection.map(reservation => (Object.assign(Object.assign({}, getProductData(reservation.ticker, {
        ticker: reservation.ticker,
        title: reservation.title,
        minPrice: reservation.totalRate,
    })), { variant: `${reservation.configurationName}, ${reservation.mealPlanName}, ${reservation.conditionName}`, brand: propertyTicker, quantity: reservation.quantity, dimension2: reservation.conditionName, dimension3: reservation.mealPlanName })));
    pushDataLayer({
        event: "eec.checkout",
        ecommerce: {
            checkout: {
                actionField: {
                    step: 1,
                },
                products,
            },
        },
    });
};
export const pushPurchaseEvent = (propertyTicker, comiNeto, reservation) => {
    if (!reservation || !reservation.roomStays) {
        return;
    }
    const products = reservation.roomStays.map(roomStay => (Object.assign(Object.assign({}, getProductData(roomStay.id, {
        ticker: roomStay.ticker,
        title: roomStay.title,
        minPrice: roomStay.totalRate,
    })), { variant: `${roomStay.configurationName}, ${roomStay.mealPlanName}, ${roomStay.conditionName}`, brand: propertyTicker, quantity: roomStay.quantity, dimension2: roomStay.conditionName, dimension3: roomStay.mealPlanName, dimension4: roomStay.extras })));
    pushDataLayer({
        event: "eec.purchase",
        ecommerce: {
            currencyCode: reservation.currency,
            purchase: {
                actionField: {
                    id: reservation.id,
                    revenue: reservation.totalRate,
                    tax: reservation.totalRate &&
                        comiNeto &&
                        (reservation.totalRate - reservation.totalRate * comiNeto).toFixed(2),
                    shipping: 0,
                    coupon: reservation.promoCodes.join(","),
                },
                products,
            },
        },
    });
};
export const pushRefundEvent = (reservationId, roomStayId, quantity) => {
    pushDataLayer({
        event: "eec.refund",
        ecommerce: {
            refund: {
                actionField: {
                    id: reservationId,
                },
                products: [
                    {
                        id: roomStayId,
                        quantity,
                    },
                ],
            },
        },
    });
};
